import csMessages from "../locales/cs_CZ";

const csLang = {
  messages: {
    ...csMessages,
  },
  locale: "cs-CZ",
};
export default csLang;
